import React, {useEffect} from 'react';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import Home from './pages/Home'; // Create a simple Home component
import Dashboard from './pages/Dashboard';
import {HashRouter as Router, Navigate, Outlet, Route, Routes, useLocation} from "react-router-dom";

const RemovingTrailingSlash = () => {
  const location = useLocation();
  const { pathname } = location;

  if (pathname.length > 1 && (pathname.endsWith('/'))) {
    return <Navigate to={pathname.slice(0, -1) + location.search} replace />
  }

  return <Outlet />;
};

const App = () => {

  return (
      <div className="App">
        <Router /* basename="/acsMbsaqip" */>
          <AuthProvider>
            <Layout>
              <Routes>
                <Route element={<RemovingTrailingSlash />}>
                  {/*<Route exact path="/dashboard" render={() => (*/}
                  {/*    isAuthenticated ? (*/}
                  {/*        <Dashboard />*/}
                  {/*    ) : (*/}
                  {/*        <Redirect to="/acsNsqipData" />*/}
                  {/*    )*/}
                  {/*)} />*/}
                  <Route path="/" element={<Home />} />
                  <Route path="/acsMbsaqip" element={<Home />} />
                  <Route path = "/dashboard" name="username" element={<Dashboard />} />
                  <Route path="*" element={<Navigate to="/home" replace />} />
                </Route>
              </Routes>
            </Layout>
          </AuthProvider>
        </Router>
      </div>
  );
};

export default App;
